
  import {Component, Prop, Vue, Watch} from "vue-property-decorator";
  import LoadingOverlay from "../../core/LoadingOverlay.vue";
  import {Voucher, VoucherKosten} from "../../../models/voucherI";
  import VendorService from "../../../services/vendor.service"
  import AuthService from "../../../services/auth.service"
  import StaticData from "../../../staticdata/staticdata"
  import VoucherService from "../../../services/voucher.service"
  import {FileReadUtils} from "../../../utils/filereadutils";
  import VoucherAttachmentService from "@/services/voucherattachments.service";
  import VoucherDetailsSignatures from "../VoucherDetailsDialogComponents/VoucherDetailsSignatures.vue";
  import ApproveDialog from "../dialogs/ApproveDialog.vue";
  import DeclineDialog from "../dialogs/DeclineDialog.vue";
  import { BankAccount } from "@/models/vendor";

  @Component({
    components: {LoadingOverlay, VoucherDetailsSignatures, ApproveDialog, DeclineDialog},
  })
  export default class VoucherDialog extends Vue {

    @Prop({default: null})
    vendor: any;

    @Prop({default: null})
    selectedVoucher: Voucher;

    @Prop({default: 'nowhere'})
    source: string;

    @Prop({default: ''})
    newVoucherType: string;

    private requiredAndMoney= [
      (v: string) => !!v || 'Feld muss ausgefüllt sein',
      (v: string) => /^[0-9]+(\,[0-9]{1,2})?$/.test(v) || 'Formatierung nicht korrekt'
    ];

    private money= [
      (v: string) => !v || /^[0-9]+(\,[0-9]{1,2})?$/.test(v) || 'Formatierung nicht korrekt'
    ];

    required = [
      (v: string) => !!v || 'Feld muss ausgefüllt sein',
    ];

    private showOverlay = false;

    private voucher: Voucher = {
      advanceReceived: false,
      advanceAmount: "",
      voucherCostsSet: [{}],
      gesamtBetrag: 0
    };

    private locVendor: any = {};

    private loading: boolean = false;

    private claimentVendorItems =  [];
    private claimentVendorSearch: string = '';
    private claimentVendorSelection = null;
    private paymentBankAccountItems = [];
    private voucherAttachmentInput: any[] = [];
    private voucherAttachmentsForEdit: any[] = [];

    private editEnabled: boolean = false;

    private isMohtamimUser: boolean = false;
    private isMohtamimMuhasibUser: boolean = false;
    private isMoawinMuhasibUser: boolean = false;
    private isMohtamimMaalUser: boolean = false;
    private comingFromOpenVouchers: boolean = false;

    private voucherApproveDialogVisible: boolean = false;
    private voucherDeclineDialogVisible: boolean = false;

    private voucherLoaded = false;

    private voucherApprovalParam: any = null;

    private mohtamimDepartment: any = null;

    private fileRules = [
      (v: any) => !!v || 'Dokument hochladen',
      (v: any) => (v && v.length > 0) || 'Dokument hochladen',
    ];

    created() {
      this.showOverlay = true;
      let userRoles = AuthService.getRoles();

      //TODO: currently there is no department data in the JWT Token
      this.mohtamimDepartment = JSON.parse((localStorage.getItem("user") || '{}')).department;

      if (userRoles.indexOf("ROLE_MOHTAMIM") >= 0) {
        this.isMohtamimUser = true;
      }

      if (userRoles.indexOf("ROLE_MOHTAMIM_MUHASIB") >= 0) {
        this.isMohtamimMuhasibUser = true;
      }

      if (userRoles.indexOf("ROLE_MOAWIN_MUHASIB") >= 0) {
        this.isMoawinMuhasibUser = true;
      }

      if (userRoles.indexOf("ROLE_MOHTAMIM_MAAL") >= 0) {
        this.isMohtamimMaalUser = true;
      }

      if(this.source === 'OpenVouchers') {
        this.comingFromOpenVouchers = true;
      }

      if (((this.source === 'OpenVouchers' && this.selectedVoucher.status !== 'PARKED') || this.source == 'CreateNewVoucher') && (this.isMohtamimUser || this.isMohtamimMuhasibUser || this.isMoawinMuhasibUser)){
        this.editEnabled = true;
      }
      // Maal: edit only in "Voucher erstellen", in "Offene Voucher" the approve/decline buttons stay
      if (this.source == 'CreateNewVoucher' && this.isMohtamimMaalUser) {
        this.editEnabled = true;
      }
      if(this.selectedVoucher) {
        VoucherService.getVoucherDetails(this.selectedVoucher.id)
        .then(
          (response: any) => {
            this.voucher = response.data;
            this.locVendor = response.data.vendor;
            if(response.data.claimentVendor) {
              //@ts-ignore
              this.claimentVendorItems.push(response.data.claimentVendor);
              //@ts-ignore
              this.claimentVendorSelection = response.data.claimentVendor;
            }
             //TODO: Check for when coming from edit
             this.claimentVendorChanged();
            //@ts-ignore
            for (var i = 0; i < this.voucher.voucherCostsSet.length; i++) {
              //this needs do be done for database:
              //@ts-ignore
              this.voucher.voucherCostsSet[i].amount = this.voucher.voucherCostsSet[i].amount.toString().replace(".", ",");
            }
            if(this.voucher.advanceAmount) {
              this.voucher.advanceAmount = this.voucher.advanceAmount.toString().replace(".", ",");
            }
            VoucherAttachmentService.getMetaForAttachments(this.selectedVoucher.id)
              .then((response: any) => {
                this.voucherAttachmentsForEdit = [];
                for (let i = 0; i < response.data.length; i++) {
                  this.voucherAttachmentsForEdit.push(response.data[i]);
                }
                this.showOverlay = false;
                this.voucherLoaded = true;
              })
              .catch((error: any) => {
                this.$notify({
                  group: 'foo',
                  title: 'Fehler',
                  text: error,
                  type: 'error'
                });
              })
              .finally(() => {
                setTimeout(() => {
                  this.showOverlay = false;
                  this.voucherLoaded = true;
                }, 5000);
              });
          });
      } else {
        // Coming from create new voucher view:
        if (this.vendor) {
          this.locVendor = this.vendor;
          //TODO: Check for when coming from edit
          this.claimentVendorChanged();
          this.showOverlay = false;
          this.voucherLoaded = true;
        }
      }
    }

    @Watch('claimentVendorSearch')
    onPropertyChanged(value: string, oldValue: string) {
      if (value && value !== this.claimentVendorSelection) {
        this.loading = true
        VendorService.searchVendor(value).then((response: any) => {
          this.claimentVendorItems = response.data;
          this.loading = false;
        });
      }
    }

    @Watch('voucher.mainExpense')
    onPropertyChanged2(value: string, oldValue: string) {
      if (oldValue) {
        this.voucher.subMainExpense = '';
        this.voucher.subSubMainExpense = '';
      }
    }

    @Watch('voucher.subMainExpense')
    onPropertyChanged3(value: string, oldValue: string) {
      if (oldValue) {
        this.voucher.subSubMainExpense = '';
      }
    }

    getClaimentVendorItemText(item: any) {
      if(item.phoneNo) {
        return `${item.name}, ${item.aimsId}, ${item.phoneNo}`;
      }
      return `${item.name}, ${item.aimsId}`;
    }

    getSubMainExpenseItems() {
      if(this.voucher.mainExpense == 'Central Share') {
        return ['2020-21', '2021-22', '2022-23', '2023-24', '2024-25'];
      }
      if(this.voucher.mainExpense == 'Local Share') {
        return ['Majlis', 'Region'];
      }
      if(this.voucher.mainExpense == 'National Share') {
        return ['National Abteilungen', 'Salana Ijtema Khuddam', 'Salana Ijtema Atfal', 'Unforseen'];
      }
      if(this.voucher.mainExpense == 'Wirtschaft Betrieb') {
        return ['Testzentrum', 'Khuddam Shop', 'Bazar - Jalsa', 'Bazar - Ijtema', 'Nuur ud Din', 'Charity Walk' ];
      }
    }

    showSubSubMainExpenseSelect() {
      let a = [
        'National Abteilungen',
        'Salana Ijtema Khuddam',
        'Salana Ijtema Atfal',
        'Unforseen',
        'Testzentrum',
        'Khuddam Shop',
        'Bazar - Jalsa',
        'Bazar - Ijtema',
        'Nuur ud Din',
      ]
      if(this.voucher.subMainExpense && a.includes(this.voucher.subMainExpense)){
        return true;
      }
      return false;
    }

    showSubSubMainExpenseTextField() {
      let a = [
        'Charity Walk'
      ]
      if(this.voucher.subMainExpense && a.includes(this.voucher.subMainExpense)){
        return true;
      }
      return false;
    }

    getSubSubMainExpenseItems(){
      if(this.voucher.subMainExpense == 'National Abteilungen') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Salana Ijtema Khuddam') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Salana Ijtema Atfal') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Unforseen') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Testzentrum') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Khuddam Shop') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Bazar - Jalsa') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Bazar - Ijtema') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Nuur ud Din') {
        return ['2020', '2021', '2022', '2023', '2024', '2025'];
      }
      if(this.voucher.subMainExpense == 'Charity Walk') {
        return ['Köln', 'Frankfurt am Main'];
      }
    }

    getAllMajalis(){
      return StaticData.getAllMajalis();
    }

    getAllRegions(){
      return StaticData.getAllRegions();
    }

    async createOrEditVoucher() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.showOverlay = true;
        //@ts-ignore
        for (var i = 0; i < this.voucher.voucherCostsSet.length; i++) {
          //this needs do be done for database:
          //@ts-ignore
          this.voucher.voucherCostsSet[i].amount = this.voucher.voucherCostsSet[i].amount.toString().replace(",", ".")
        }

        if (this.voucher.advanceAmount) {
          this.voucher.advanceAmount = this.voucher.advanceAmount.toString().replace(",", ".")
        }

        let data = {
          vendorId: this.locVendor.id,
          voucher: this.voucher,
          //@ts-ignore
          claimentVendorId: this.claimentVendorSelection ? this.claimentVendorSelection.id : null,
          voucherAttachments: await this.getVoucherAttachments(),
          type: this.selectedVoucher ? this.selectedVoucher.type : this.newVoucherType
        }

        if(!this.selectedVoucher) {
          VoucherService.createVoucher(data)
          .then((response: any) => {
            this.$notify({
              group: 'foo',
              title: 'Info',
              text: response.data,
              type: 'success'
            });
            (this.$refs.form as Vue & { reset: () => boolean }).reset();
            this.showOverlay = false;
            //@ts-ignore
            this.$emit('event', this.locVendor);
          })
          .catch((error: any) => {
            this.$notify({
              group: 'foo',
              title: 'Fehler',
              text: error,
              type: 'error'
            });
            this.showOverlay = false
          })
          .finally(() => {
            setTimeout(() => {
              this.showOverlay = false;
            }, 5000);
          });
        } else {
          VoucherService.editVoucher(data)
            .then((response: any) => {
              this.$notify({
                group: 'foo',
                title: 'Info',
                text: response.data,
                type: 'success'
              });
              (this.$refs.form as Vue & { reset: () => boolean }).reset();
              this.showOverlay = false;
              //@ts-ignore
              this.$emit('event', this.locVendor);
            })
            .catch((error: any) => {
              this.$notify({
                group: 'foo',
                title: 'Fehler',
                text: error,
                type: 'error'
              });
              this.showOverlay = false
            })
            .finally(() => {
              setTimeout(() => {
                this.showOverlay = false;
              }, 5000);
            });
        }
      }
    }

    getExpenseHeadItems() {
      return StaticData.getVoucherKostenSetItems().map((item: any) => item.expenseHead);
    }

    getSubExpenseHeadItemsForRow(voucherKosten: VoucherKosten) {
      if(StaticData.getVoucherKostenSetItems()
        .filter(kostenart => kostenart.expenseHead == voucherKosten.expenseHead)[0]) {
          return StaticData.getVoucherKostenSetItems()
        .filter(kostenart => kostenart.expenseHead == voucherKosten.expenseHead)[0].subExpenseHeads;
        }
    }

    addRowToVoucherKostenSet() {
      //@ts-ignore
      this.voucher.voucherCostsSet.push({});
    }

    calculateGesamtBetrag() {
      this.voucher.gesamtBetrag = 0;
      //@ts-ignore
      for (var i = 0; i < this.voucher.voucherCostsSet.length; i++) {
        //@ts-ignore
        if (this.voucher.voucherCostsSet[i].amount) {
          //@ts-ignore, the 2nd '+' is important!!!
          let gesamtBetrag = this.voucher.gesamtBetrag + +(this.voucher.voucherCostsSet[i]!.amount.toString().replace(",", "."));
          this.voucher.gesamtBetrag = Math.round(gesamtBetrag * 100) / 100;
        }
      }
    }

    claimentVendorChanged(){
      if (this.claimentVendorSelection) {
        //@ts-ignore
        this.paymentBankAccountItems = this.claimentVendorSelection.bankAccounts;
      } else if(this.locVendor !== undefined && this.locVendor !== null) {
        // Take main vendor bank accounts
        this.paymentBankAccountItems = this.locVendor.bankAccounts;
      }
      if (this.paymentBankAccountItems.length > 0) {
        //@ts-ignore
        this.voucher.selectedPaymentBankAccountId = this.paymentBankAccountItems[0].id;
      } else {
        this.voucher.selectedPaymentBankAccountId = 0;
      }
    }

    removeAttachmentFromList(attachmentToDelete: any) {
      this.voucherAttachmentsForEdit = this.voucherAttachmentsForEdit.filter(attachment => attachment.id !== attachmentToDelete.id);
    }

    removeRowFromVoucherKostenSet(index: any) {
      //@ts-ignore
      this.voucher.voucherCostsSet.splice(index, 1);
      this.calculateGesamtBetrag();
    }

    downloadAttachment(id: any) {
      FileReadUtils.downloadAttachment(id);
    }

    async approveVoucher() {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        let data = {
          vendorId: this.locVendor.id,
          voucher: this.voucher,
          //@ts-ignore
          claimentVendorId: this.claimentVendorSelection ? this.claimentVendorSelection.id : null,
          voucherAttachments: await this.getVoucherAttachments()
        }

        this.voucherApprovalParam = data;
        this.voucherApproveDialogVisible = true;
      }
    }

    handleCloseVoucherApproveDialog() {
      this.voucherApproveDialogVisible = false;
      this.$emit('event');
    }

    handleCloseVoucherDeclineDialog() {
      this.voucherDeclineDialogVisible = false;
      this.$emit('event');
    }

    showVoucherDeclineReasonDialog() {
      this.voucherDeclineDialogVisible = true;
    }

    getBankDataText(item: BankAccount) {
      if(item.accountHolder) {
        return `${item.iban}, Inhaber: ${item.accountHolder}`;
      }
      return `${item.iban}`;
    }

    getDifferenceTotalAndAdvance() {
      //@ts-ignore
      return ((Math.round(+(+this.voucher.gesamtBetrag - +(this.voucher.advanceAmount.toString().replace(",", ".")))* 100) /100).toString().replace(".", ","));
    }

    getItemsForMainExpense() {
      if(this.isMohtamimUser)
        return ['Local Share', 'National Share', 'Wirtschaft Betrieb'];
      else
        return ['Central Share', 'Local Share', 'National Share', 'Wirtschaft Betrieb'];
    }

    getSelectableDepartments() {
      let allDepartments = ['Aitmad','Atfal','Khidmat-e-Khalq','Taleem','Tarbiyyat','Tabligh','Maal','Muhasib','Jaidad','Sehat-e-Jismani','Nuur-ud-din','Tarbiyyat Nau Mobaeen','Additional Tarbiyyat','Additional Tabligh','Muqami','Waqar-e-Amal','Sanat-o-Tijarat','Ishaat','Tahrik-e-Jadid','Tajneed','Umumi','Umur-e-Tulaba','Waqf-e-Nau','Einkauf'];
      if (this.isMohtamimUser) {
        return allDepartments.filter(dept => dept == this.mohtamimDepartment);
      }
      return allDepartments;
    }

    async getVoucherAttachments() {
      let voucherAttachments = [];
        //Handle documents added in the file input field:
        if (this.voucherAttachmentInput != null) {
          for (var i = 0; i < this.voucherAttachmentInput.length; i++) {
            let binaryString = await FileReadUtils.readFileAsync(this.voucherAttachmentInput[i]);
            //@ts-ignore
            let encodedBinaryString = window.btoa(binaryString.toString());

            let voucherAttachment = {
              id: null,
              data: encodedBinaryString,
              fileName: this.voucherAttachmentInput[i].name,
              fileType: this.voucherAttachmentInput[i].type
            };

            voucherAttachments.push(voucherAttachment);
          }
        }

        for (var i = 0; i < this.voucherAttachmentsForEdit.length; i++) {
          let voucherAttachment = {
              // in backend only id is important:
              id: this.voucherAttachmentsForEdit[i].id
            };
            voucherAttachments.push(voucherAttachment);
        }
        return voucherAttachments;
    }
  }
